export const formatPoints = (points) => {
  if (typeof points !== 'number') return '0';
  return points.toLocaleString();
};

export const calculatePointsChange = (currentPoints, adjustment) => {
  const current = Number(currentPoints) || 0;
  const change = Number(adjustment) || 0;
  return current + change;
};

export const validatePointsAdjustment = (points, reason) => {
  const errors = [];
  
  if (!points || isNaN(Number(points))) {
    errors.push('Points must be a valid number');
  }
  
  if (!reason || reason.trim().length === 0) {
    errors.push('Reason is required');
  }
  
  if (reason && reason.trim().length < 5) {
    errors.push('Reason must be at least 5 characters');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const getPointsTransactionColor = (type) => {
  const colors = {
    'ADMIN_ADJUSTMENT': 'text-blue-600',
    'REFERRAL_BONUS': 'text-green-600',
    'PURCHASE': 'text-red-600',
    'REFUND': 'text-orange-600',
    'BONUS': 'text-purple-600'
  };
  return colors[type] || 'text-gray-600';
};

export const formatPointsTransaction = (transaction) => {
  return {
    ...transaction,
    formattedPoints: formatPoints(Math.abs(transaction.points)),
    isPositive: transaction.points > 0,
    color: getPointsTransactionColor(transaction.type),
    date: new Date(transaction.createdAt).toLocaleDateString()
  };
};
